import { PAYER_IDENTITY_OTHER } from 'constants/ui';

export const formatPartnerFieldsForMetadata = (
  partnerFields: Record<string, string>,
): Record<string, string> => {
  return Object.entries(partnerFields).reduce(
    (acc, [key, value]) => {
      if (value) {
        acc[`partner_${key}`] = value;
      }
      return acc;
    },
    {} as Record<string, string>,
  );
};

export const createPayerIdentityMetadata = (
  payerIdentity: string | undefined,
  partnerFields: Record<string, string>,
): Record<string, string> => {
  let metadata: Record<string, string> = {};

  if (payerIdentity) {
    metadata.payer_identity = payerIdentity;

    if (payerIdentity === PAYER_IDENTITY_OTHER) {
      const partnerMetadata = formatPartnerFieldsForMetadata(partnerFields);
      metadata = { ...metadata, ...partnerMetadata };
    }
  }

  return metadata;
};
